import { EnumBasedItem, EnumBasedService, createEnumService } from "./base";

export enum PracticalTrainingType {
  FACE_TO_FACE = "face_to_face",
  SIMULATION = "simulation",
  HELICOPTER = "helicopter",
}

export class PracticalTraining extends EnumBasedItem<PracticalTrainingType> {}

const baseService = createEnumService(PracticalTrainingType, PracticalTraining);

class PracticalTrainingService extends EnumBasedService<PracticalTraining, PracticalTrainingType> {
  constructor() {
    super(baseService.getOptions());
  }

  parsePracticalTrainingString(practicalTrainingStr?: string): PracticalTraining[] {
    if (!practicalTrainingStr) return [];

    const codes = practicalTrainingStr.trim().split(/\s+/);
    return codes.map((code) => this.getByCode(code)).filter((pt): pt is PracticalTraining => pt !== undefined);
  }

  formatPracticalTrainingForApi(practicalTrainingOptions?: PracticalTraining[]): string {
    if (!practicalTrainingOptions || practicalTrainingOptions.length === 0) return "";

    // TODO: Refactor this once API accepts less strange input
    let retVal = "";
    for (let i = 0; i < practicalTrainingOptions.length; i++) {
      retVal += practicalTrainingOptions[i].code + " ";
    }
    return retVal;
  }
}

const practicalTrainingService = new PracticalTrainingService();
export default practicalTrainingService;
